import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { setLanguage } from '../store/correcttrackSlice';
import AuthUtil from './Utils/AuthUtil';
import UserApiService from '../api/UserApiService';
import { SUPPORTED_LOCALES } from '../i18n';

const userApi = new UserApiService();

const LANGUAGE_OPTIONS = [
    { code: 'en', label: 'English' },
    { code: 'ru', label: 'Русский' },
    { code: 'fr', label: 'Français' },
    { code: 'en-XA', label: 'Pseudo (⟦XA⟧)' }
];

const LanguageSwitcher = () => {
    const dispatch = useDispatch();
    const userToken = useSelector(state => state.correcttrack.userToken);
    const language = useSelector(state => state.correcttrack.language) || 'en';

    if (!AuthUtil.isTranslator(userToken)) {
        return null;
    }

    const handleChange = (event) => {
        const next = event.target.value;
        if (!SUPPORTED_LOCALES.includes(next)) return;
        dispatch(setLanguage(next));
        // en-XA is a translator-only pseudo-locale; don't persist it server-side.
        if (next !== 'en-XA') {
            userApi.updatePreferredLocale(next).catch(() => { /* non-fatal */ });
        }
    };

    return (
        <FormControl size="small" sx={{ minWidth: 130 }}>
            <Select
                value={language}
                onChange={handleChange}
                sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.08)',
                    '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.4)' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.7)' },
                    '.MuiSvgIcon-root': { color: 'white' },
                }}
            >
                {LANGUAGE_OPTIONS.map(opt => (
                    <MenuItem key={opt.code} value={opt.code}>{opt.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default LanguageSwitcher;
